import * as types from '../constants/actionTypes';
import initialState from '../reducers/initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function eventReducer(state = initialState.contracts, action) {
  switch (action.type) {
    case types.LOAD_CONTRACTS:
      return Object.assign({}, state, {
        contracts: action.data
      });

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/reducers/contractReducer.js
 **/